import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'help',
    component: () => import(/* webpackChunkName: "about" */ '../views/HelpDocuments.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/HomeView.vue')
  },
  {
    path: '/update_log',
    name: 'update_log',
    component: () => import(/* webpackChunkName: "about" */ '../views/Updatelog.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
